import { Grid, OutlinedInput, styled, TableCell } from "@mui/material";

export const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 320, boxShadow: theme.shadows[8] },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));
export const TabCell = styled(TableCell)({
  minWidth: 160,
  maxWidth: 240,
});
export const RowCell = styled(TableCell)({
  maxWidth: 240,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});
export const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});
export const GridFlexStart = styled(Grid)({
  display: "flex",
  justifyContent: "flex-start",
});
export const GridFlexEnd = styled(Grid)({
  display: "flex",
  justifyContent: "flex-end",
});
